(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["attire-age-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('attire-age-selector')) {
    class AttireAgeSelector extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.eventScope = this.productInfo || document;

        this.handleAgeChange = this.handleAgeChange.bind(this);
        this.handleNativeChange = this.handleNativeChange.bind(this);
        this.handleVariantChanged = this.handleVariantChanged.bind(this);

        this.addEventListener('change', this.handleAgeChange);
        this.eventScope.addEventListener('change', this.handleNativeChange);
        document.addEventListener('variant:changed', this.handleVariantChanged);

        requestAnimationFrame(() => this.syncFromNative());
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.handleAgeChange);
        this.eventScope?.removeEventListener('change', this.handleNativeChange);
        document.removeEventListener('variant:changed', this.handleVariantChanged);
      }

      get variantPicker() {
        const scope = this.productInfo || document;
        const productId = String(this.dataset.productId || '');
        const pickers = Array.from(scope.querySelectorAll('variant-picker'));

        return (
          pickers.find((picker) => String(picker.dataset.productId || '') === productId) ||
          pickers[0] ||
          null
        );
      }

      get sizeField() {
        const picker = this.variantPicker;
        if (!picker) return null;

        const wantedName = this.normalize(this.dataset.sizeOptionName).toLowerCase();

        return (
          Array.from(picker.querySelectorAll('[data-picker-field]')).find((field) => {
            return this.normalize(field.dataset.optionName).toLowerCase() === wantedName;
          }) || null
        );
      }

      normalize(value) {
        return String(value ?? '').trim();
      }

      getSelectedSize(field) {
        const select = field.querySelector('select');
        if (select) return this.normalize(select.value);

        const checked = field.querySelector('input[type="radio"]:checked');
        return checked ? this.normalize(checked.value) : '';
      }

      findNativeControl(field, size) {
        const wantedSize = this.normalize(size);
        const select = field.querySelector('select');

        if (select) {
          return (
            Array.from(select.options).find((option) => this.normalize(option.value) === wantedSize) ||
            null
          );
        }

        return (
          Array.from(field.querySelectorAll('input[type="radio"]')).find(
            (input) => this.normalize(input.value) === wantedSize
          ) || null
        );
      }

      isNativeUnavailable(control, ageNode) {
        if (!control) return true;

        if (control.tagName === 'OPTION') {
          return control.disabled || ageNode.dataset.initialUnavailable === 'true';
        }

        return (
          control.disabled ||
          control.classList.contains('disabled') ||
          Boolean(control.closest('.m-product-option--node__unavailable'))
        );
      }

      syncFromNative() {
        const field = this.sizeField;
        if (!field) return;

        const selectedSize = this.getSelectedSize(field);
        let selectedAge = '';

        this.querySelectorAll('[data-age-size]').forEach((ageInput) => {
          const size = this.normalize(ageInput.dataset.ageSize);
          const nativeControl = this.findNativeControl(field, size);
          const ageNode = ageInput.closest('[data-age-node]');
          const isSelected = size === selectedSize;

          ageInput.checked = isSelected;
          ageInput.disabled = !nativeControl || Boolean(nativeControl.disabled);

          if (ageNode) {
            ageNode.classList.toggle(
              'm-product-option--node__unavailable',
              this.isNativeUnavailable(nativeControl, ageNode)
            );
          }

          if (isSelected) selectedAge = ageInput.dataset.ageLabel || ageInput.value;
        });

        const selectedLabel = this.querySelector('[data-age-selected]');
        if (selectedLabel) selectedLabel.textContent = selectedAge;
      }

      selectNativeSize(size) {
        const field = this.sizeField;
        if (!field) return;

        const control = this.findNativeControl(field, size);
        if (!control || control.disabled) {
          this.syncFromNative();
          return;
        }

        if (control.tagName === 'OPTION') {
          const select = control.parentElement;
          if (!select) return;

          if (select.value !== control.value) {
            select.value = control.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            this.syncFromNative();
          }
          return;
        }

        if (!control.checked) {
          control.click();
        } else {
          this.syncFromNative();
        }
      }

      handleAgeChange(event) {
        const ageInput = event.target.closest?.('[data-age-size]');
        if (!ageInput || !this.contains(ageInput)) return;

        this.selectNativeSize(ageInput.dataset.ageSize);
      }

      handleNativeChange(event) {
        const picker = this.variantPicker;
        const field = this.sizeField;

        if (!picker || !field || !picker.contains(event.target) || !field.contains(event.target)) return;
        this.syncFromNative();
      }

      handleVariantChanged() {
        requestAnimationFrame(() => this.syncFromNative());
      }
    }

    customElements.define('attire-age-selector', AttireAgeSelector);
  }
  } catch(e) { console.error(e); }
})();

})();
